import { MDClinician } from "@/Common/Api/MedfarDictionaries/Dto/Responses/MDClinician";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { IReferralDoctorModel } from "@/Common/Models/IReferralDoctorModel";
import { Gender } from "@/Common/Models/Patient/PatientEnums";
import { Person } from "@/Common/Models/Person/Person";

class LicencedIntervenor implements IReferralDoctorModel {
    public Id: string;
    public LicenceNumber: string;
    public FirstName: string;
    public LastName: string;
    public LicenceOrganisationRuleId: string;
    public LicenceOrganisationSpecialisationId: string;
    public SpecialityDetails: string;
    public StatusDetails: string;
    public PermitDetails: string;
    public Address: string;
    public Phone: string;
    public Fax: string;
    public Gender: string;
    public SearchableSummary1: string;
    public SearchableSummary2: string;
    public SearchableSummary3: string;
    public SearchableSummary4: string;
    public DeactivateAutoUpdate: string;
    public LastUpdateFromCMQ: string;
    public IsActive: string;

    // Soft Var
    public OrganisationCode: string;
    public IsHighlighted: boolean;
    public ItemId: number;

    public constructor(fields?: Partial<LicencedIntervenor>, shouldGenerateNewId: boolean = true) {
        Object.assign(this, fields);

        if (shouldGenerateNewId)
            this.ItemId = sessionStore.newId();
    }

    public get Name(): string { return this.LastName + ", " + this.FirstName; }

    public static ToMDClinician(doc: LicencedIntervenor): MDClinician {
        var mdClinician = new MDClinician();
        mdClinician.Id = GuidHelper.Empty();
        mdClinician.Name = doc.LastName + ", " + doc.FirstName;
        mdClinician.Speciality = doc.StatusDetails;
        mdClinician.PracticianStatus = doc.StatusDetails;
        mdClinician.Address = doc.Address.replace(/(?:\r\n|\r|\n)/g, " ");
        mdClinician.PhoneNumber = doc.Phone;
        mdClinician.Identifier = doc.LicenceNumber;
        mdClinician.PermitType = doc.PermitDetails;
        mdClinician.Gender = doc.Gender;
        mdClinician.RamqNumber = doc.LicenceNumber;

        mdClinician.AvailableStatusLookups = cacheStore.GetClinicianPermitStatusLookups();
        mdClinician.AvailablePermitTypeLookups = cacheStore.GetClinicianPermitTypeLookups();

        return mdClinician;
    }

    public static GetLicence(doc: LicencedIntervenor): string {
        if (doc.LicenceNumber == null)
            return "";

        return doc.LicenceNumber;
    }

    public static FromPerson(person: Person): LicencedIntervenor {
        return new LicencedIntervenor({
            Id: person.Identifier,
            LicenceNumber: person.Licence,
            FirstName: person.FirstName,
            LastName: person.LastName,
            LicenceOrganisationRuleId: person.OrganizationRuleId,
            Address: person.GetFormattedAddress(),
            Phone: person.PreferedPhone,
            Gender: person.gender === Gender.Female ? "Female" : (person.gender === Gender.Male ? "Male" : null)
        });
    }

    public getFullDisplayLabel(): string {
        const license = LicencedIntervenor.GetLicence(this);

        return this.LastName
            + ", "
            + this.FirstName
            + (license ? ` (${license})` + (this.OrganisationCode ? ` ${this.OrganisationCode}` : "") : "");
    }
}

export { LicencedIntervenor };
